import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import LanguageToggle from './LanguageToggle';
import MobileMenu from './MobileMenu';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { label: 'Inicio', labelEn: 'Home', path: '/homepage', icon: 'Home' },
    { label: 'Servicios', labelEn: 'Services', path: '/services-catalog', icon: 'Wrench' },
    { label: 'Galería', labelEn: 'Gallery', path: '/project-gallery', icon: 'Image' },
    { label: 'Nosotros', labelEn: 'About', path: '/about-us', icon: 'Users' },
    { label: 'Blog', labelEn: 'Blog', path: '/blog-resources', icon: 'BookOpen' },
    { label: 'Contacto', labelEn: 'Contact', path: '/contact-quote-request', icon: 'Phone' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-surface shadow-subtle fixed top-0 left-0 right-0 z-1000">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/homepage" className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Waves" size={24} color="white" />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl font-heading font-bold text-primary">
                  BAC Pool CR
                </h1>
                <p className="text-xs font-caption text-text-secondary">
                  Pool Cleaning Services
                </p>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium nav-transition ${
                  location.pathname === item.path
                    ? 'text-primary bg-primary/10' :'text-text-primary hover:text-primary hover:bg-primary/5'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Right Side Actions */}
          <div className="flex items-center space-x-4">
            {/* Emergency Contact */}
            <div className="hidden lg:flex items-center space-x-2 text-sm">
              <Icon name="Phone" size={16} className="text-accent" />
              <span className="font-mono text-text-secondary">+506 2253-4791</span>
            </div>

            {/* Language Toggle */}
            <LanguageToggle />

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-text-primary hover:text-primary hover:bg-primary/5 nav-transition"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={closeMobileMenu}
        navigationItems={navigationItems}
        currentPath={location.pathname}
      />
    </header>
  );
};

export default Header;